export enum LocalStorageKey {
  PaginationPageSize = 'PaginationPageSize',
}
